import jQuery from 'jquery';

(function () {
  // force jquery-migrate to be muted
  jQuery.migrateMute = true;
}());
